import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faEye,
  faChartArea,
  faCalendarAlt,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faSort,
  faPaperPlane,
  faCheckCircle,
  faTimesCircle,
  faClock,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { URL } from "../../common/Url";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { userid, token, type } from "../../common/AdminAuth";
import { Link } from "react-router-dom";
import useSelectedDate from "../../../store/UseFilterDateStore";
import { getMasterCountryList, getUserPriceList } from "../../../api/api";
import { getCountryName } from "../../Utils/Helper";

const SummaryReport = () => {
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  var date = new Date();
  var todatdate =
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1) +
    "-" +
    ("0" + date.getDate()).slice(-2);

  const setStoreDateFrom = useSelectedDate((state) => state.setStoreDateFrom);
  const setStoreDateTo = useSelectedDate((state) => state.setDateTo);

  const selctedDateFrom = useSelectedDate((state) => state.selctedDateFrom);
  const selctedDateTo = useSelectedDate((state) => state.selctedDateTo);

  const [DateFrom, setDateFrom] = useState(selctedDateFrom);
  const [DateTo, setDateTo] = useState(selctedDateTo);
  const [showDateFrom, setshowDateFrom] = useState(new Date());
  const [showDateTo, setshowDateTo] = useState(new Date());
  const [dateRange, setDateRange] = useState("today");
  const [showDateRnage, SetshowDateRnage] = useState(false);
  const [filterUser, SetfilterUser] = useState(false);
  const [userList, setuserList] = useState([]);
  const [selectUser, setselectUser] = useState("");
  const [summaryReportData, setsummaryReportData] = useState([]);
  const [newSummeryData, setnewSummeryData] = useState([]);
  const [uniqueData, setUniqueData] = useState([]);
  const [isloading, setisloading] = useState(false);
  const [openRows, setOpenRows] = useState({});
  const [rowDetails, setRowDetails] = useState({});
  const [rowLoading, setRowLoading] = useState({});

  const [companyList, setcompanyList] = useState([]);
  const [rowPrices, setRowPrices] = useState({});

  // Find the price entry for a country code (e.g. "61") from the user's
  // price list, whose `regex` looks like "^([\+]?61)".
  const findPrice = (username, countryCode) => {
    const prices = rowPrices[username];
    if (!prices || prices.length === 0) return null;
    const code = String(parseInt(countryCode));
    const matches = prices.filter((p) => {
      const m = String(p.regex || "").match(/(\d+)/);
      return m && m[1] === code;
    });
    if (matches.length === 0) return null;
    const country = companyList.find(
      (c) => parseInt(c.country_code) === parseInt(countryCode)
    );
    return (
      matches.find(
        (p) => country && p.country_name === country.country_name
      ) || matches[0]
    );
  };

  const fmtCost = (n) =>
    Number(n).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4,
    });

  const toggleRow = (username) => {
    // only one accordion open at a time
    setOpenRows(openRows[username] ? {} : { [username]: true });
  };

  // Country breakdown rows for one user, taken from the summary response.
  const buildRows = (data, username) => {
    const rows = [];
    const userData = data[username] || {};
    Object.keys(userData).forEach((reportDate) => {
      Object.keys(userData[reportDate]).forEach((sernderid) => {
        rows.push({
          date: reportDate,
          sernderid: sernderid,
          count: userData[reportDate][sernderid],
        });
      });
    });
    // latest date first
    rows.sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
    return rows;
  };

  // Load every user's breakdown and price list so the parent rows can show
  // total customer cost / vendor cost / profit without opening the accordion.
  const loadAllDetails = (data) => {
    const users = Object.keys(data);
    const details = {};
    const loading = {};
    users.forEach((u) => {
      details[u] = buildRows(data, u);
      loading[u] = true;
    });
    setRowDetails(details);
    setRowLoading(loading);
    setRowPrices({});
    setOpenRows({});
    users.forEach((u) => {
      getUserPriceList(u)
        .then((res) => {
          setRowPrices((prev) => ({
            ...prev,
            [u]: res.data.success === true ? res.data.data : [],
          }));
        })
        .catch(() => setRowPrices((prev) => ({ ...prev, [u]: [] })))
        .finally(() => setRowLoading((prev) => ({ ...prev, [u]: false })));
    });
  };

  // Sum of customer cost, vendor cost and profit over all of a user's countries.
  const userCosts = (username) => {
    if (rowPrices[username] === undefined) return null;
    let customer = 0;
    let vendor = 0;
    let matched = false;
    (rowDetails[username] || []).forEach((d) => {
      const p = findPrice(username, d.sernderid);
      if (p) {
        const t = totalsOf(d.count).t;
        customer += p.cost * t;
        vendor += p.buy_price * t;
        matched = true;
      }
    });
    return { customer, vendor, profit: customer - vendor, matched };
  };

  useEffect(() => {
    summaryReport();
    getUserDetails();
    getMasterCountryList().then((res) => {
      setcompanyList(res.data.success === true ? res.data.data : []);
    });
  }, []);

  const summaryReport = () => {
    seterror({ errarStatus: false });
    setisloading(true);
    ShowsummaryReportData("");
    fetch(
      `${URL}report.php?user_id=${userid}&method=summarynew&date_from=${DateFrom}&date_to=${DateTo}&search_user_id=${selectUser}&token=${token}&user_type=${type}`
    ).then((response) => {
      response.json().then((result) => {
        if (result.success === true) {
          setsummaryReportData(result.data);
          loadAllDetails(result.data);
          ShowsummaryReportData(result.data);
          setisloading(false);
        } else {
          setisloading(false);
          seterror({
            errarStatus: true,
            errorMessage: result.message,
            bgcolor: "alert alert-danger",
          });
          ShowsummaryReportData("");
        }
      });
    });
  };

  const handleDateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    setDateFrom(dated);
    setStoreDateFrom(dated);
    setshowDateFrom(date);
  };

  const handleDateTo = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    setDateTo(dated);
    setStoreDateTo(dated);
    setshowDateTo(date);
  };

  const getUserDetails = () => {
    fetch(
      `${URL}users.php?user_id=${userid}&method=retrieve&token=${token}&user_type=${type}`
    ).then((response) => {
      response.json().then((result) => {
        // console.log('user List',result);
        if (result.success === true) {
          setuserList(result.data);
        } else {
          seterror({
            errarStatus: true,
            errorMessage: result.message,
            bgcolor: "alert alert-danger",
          });
        }
      });
    });
  };

  const accountTyeHandlar = (e) => {
    setselectUser(e.target.value);
  };

  const dateRangeHandlar = (e) => {
    if (e.target.value === "customdata") {
      SetshowDateRnage(true);
      setDateRange(e.target.value);
    } else {
      SetshowDateRnage(false);
      setDateRange(e.target.value);
    }
  };

  const SelectuserWiseHandlar = (e) => {
    if (e.target.value === "AccountWise") {
      SetfilterUser(true);
      setDateRange(e.target.value);
    } else {
      SetfilterUser(false);
      setDateRange(e.target.value);
    }
  };

  const ShowsummaryReportData = (data) => {
    let DataMap = [];
    let userwise = [];
    Object.keys(data).forEach((username) =>
      // DataMap.push({'username':username})
      Object.keys(data[username]).forEach((date) =>
        //  DataMap.push({'date':date})
        Object.keys(data[username][date]).forEach((sernderID) =>
          DataMap.push(
            Object.assign({
              username: username,
              sernderid: sernderID,
              date: date,
              count: data[username][date][sernderID],
            })
          )
        )
      )
    );
    setnewSummeryData(DataMap);
    getuserIDwise(DataMap);
  };

  const getuserIDwise = (data) => {
    let newData = [];

    data.map((item) => {
      let valueOfIndexOf = newData
        .map((el) => el.username)
        .indexOf(item.username);
      // console.log(valueOfIndexOf);

      if (valueOfIndexOf >= 0) {
        newData[valueOfIndexOf].count.other =
          parseInt(
            newData[valueOfIndexOf].count.other
              ? newData[valueOfIndexOf].count.other
              : 0
          ) + parseInt(item.count.other ? item.count.other : 0);

        newData[valueOfIndexOf].count.delivered =
          parseInt(
            newData[valueOfIndexOf].count.delivered
              ? newData[valueOfIndexOf].count.delivered
              : 0
          ) + parseInt(item.count.delivered ? item.count.delivered : 0);

        newData[valueOfIndexOf].count.failed =
          parseInt(
            newData[valueOfIndexOf].count.failed
              ? newData[valueOfIndexOf].count.failed
              : 0
          ) + parseInt(item.count.failed ? item.count.failed : 0);
      } else {
        // copy so merging below doesn't mutate the original response data
        newData.push({ ...item, count: { ...item.count } });
      }
    });

    setUniqueData(newData);
  };

  const getDeliveredPercentage = (count) => {
    const totalSent =
      parseInt(count.delivered || 0) +
      parseInt(count.failed || 0) +
      parseInt(count.other || 0);
    const delivered = parseInt(count.delivered || 0);
    return totalSent > 0 ? Math.round((delivered / totalSent) * 100) : 0;
  };

  const exportToCSV = () => {
    const headers = [
      "User Name",
      "Total Sent",
      "Delivered",
      "Failed",
      "DLR Await",
    ];
    const rows = uniqueData.map((item) => {
      const delivered = parseInt(item.count.delivered || 0);
      const failed = parseInt(item.count.failed || 0);
      const other = parseInt(item.count.other || 0);
      return [item.username, delivered + failed + other, delivered, failed, other];
    });
    const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `account-summary-${DateFrom}-to-${DateTo}.csv`;
    link.click();
  };

  const num = (v) => parseInt(v || 0);
  const totalsOf = (c) => {
    const d = num(c.delivered);
    const f = num(c.failed);
    const o = num(c.other);
    return { d, f, o, t: d + f + o };
  };
  const grand = uniqueData.reduce(
    (a, it) => {
      const s = totalsOf(it.count);
      return { d: a.d + s.d, f: a.f + s.f, o: a.o + s.o, t: a.t + s.t };
    },
    { d: 0, f: 0, o: 0, t: 0 }
  );
  // Billing totals across every listed user (null until all price lists load)
  const allCosts = uniqueData.map((it) => userCosts(it.username));
  const billingLoaded = allCosts.length > 0 && allCosts.every((c) => c);
  const billing = allCosts.reduce(
    (a, c) =>
      c
        ? {
            customer: a.customer + c.customer,
            vendor: a.vendor + c.vendor,
            profit: a.profit + c.profit,
          }
        : a,
    { customer: 0, vendor: 0, profit: 0 }
  );
  const fmt = (n) => Number(n).toLocaleString();
  // whole percent, but a non-zero value under 1% keeps one decimal
  // (80 of 25,603 shows 0.3% instead of rounding down to 0%)
  const pct = (n, t) => {
    if (t <= 0) return 0;
    const v = (n / t) * 100;
    return n > 0 && v < 1 ? Math.max(0.1, Math.round(v * 10) / 10) : Math.round(v);
  };
  const fmtDate = (s) => {
    const p = String(s).split("-");
    const d = new Date(p[0], p[1] - 1, p[2]);
    return isNaN(d) ? s : d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <style>{`
        .sr-empty{padding:48px 16px;text-align:center;color:#6b7280}
        .sr-panel{border-radius:14px;border:0;box-shadow:0 2px 10px rgba(15,23,42,.06)}
        .sr-panel-head{padding:24px 28px 16px}
        .sr-panel-body{padding:0 28px 24px}
        .sr-h1{font-size:1.5rem;font-weight:700;color:#0f1f3d;margin:0}
        .sr-h1-sub{color:#4b5b76;font-size:.9rem;margin:4px 0 0}
        .sr-range{display:inline-flex;align-items:center;gap:10px;background:#fff;border:1px solid #e5e8ee;border-radius:10px;padding:9px 16px;font-size:.88rem;font-weight:500;color:#0f1f3d;box-shadow:0 1px 3px rgba(15,23,42,.06)}
        .sr-main{width:100%;border-collapse:separate;border-spacing:0}
        .sr-main thead th{background:#f3f4f7;color:#3d4b66;font-size:.72rem;letter-spacing:.05em;text-transform:uppercase;font-weight:600;padding:14px 12px;border:0;white-space:nowrap}
        .sr-main thead th:first-child{border-radius:8px 0 0 8px}
        .sr-main thead th:last-child{border-radius:0 8px 8px 0}
        .sr-main tbody td{padding:16px 12px;vertical-align:middle;border:0;border-bottom:1px solid #eceef2;color:#0f1f3d;font-size:.92rem}
        .sr-main-row{cursor:pointer}
        .sr-main-row:hover td{background:#fafbfc}
        .sr-chev{color:#1f2d4a;font-size:.8rem}
        .sr-uname{font-size:1.02rem;font-weight:500;color:#0f1f3d}
        .sr-strong{font-weight:600}
        .sr-stat{font-size:.95rem;margin-bottom:6px}
        .sr-stat b{font-size:1.1rem;font-weight:700}
        .sr-stat span{font-size:.85rem;opacity:.85}
        .sr-green{color:#1b7a43}
        .sr-red{color:#d1242f}
        .sr-amber{color:#e8920c}
        .sr-track{height:6px;width:min(230px,100%);min-width:150px;background:#e6e8ec;border-radius:3px;overflow:hidden}
        .sr-track span{display:block;height:100%;border-radius:3px;min-width:3px}
        .sr-pill-btn{display:inline-flex;align-items:center;gap:8px;background:#fff;color:#0f1f3d;border:1px solid #e1e4ea;border-radius:8px;padding:9px 16px;font-size:.88rem;font-weight:500;text-decoration:none;box-shadow:0 1px 3px rgba(15,23,42,.08);white-space:nowrap}
        .sr-pill-btn:hover{background:#f3f4f7;color:#0f1f3d}
        .sr-pill-btn.sr-sm{gap:5px;padding:4px 10px;font-size:.78rem;border-radius:6px}
        .sr-open-cell{border-bottom:0!important;background:transparent!important}
        .sr-break{background:#eef4fd;border:1px solid #d9e5f7;border-radius:10px;padding:18px 18px 18px;margin:8px 0 10px}
        .sr-globe{font-size:1.5rem;color:#2d4a7a;margin-left:6px}
        .sr-break-title{font-weight:700;color:#0f1f3d;font-size:1rem}
        .sr-break-sub{color:#4b5b76;font-size:.8rem}
        .sr-count-pill{background:#e8ecf3;color:#0f1f3d;border-radius:999px;padding:6px 14px;font-size:.78rem;font-weight:600}
        .sr-inner-wrap{background:#fff;border:1px solid #d9e5f7;border-radius:10px;overflow:hidden}
        .sr-inner{width:100%;border-collapse:collapse}
        .sr-inner thead th{background:#f7f8fa;color:#3d4b66;font-size:.72rem;letter-spacing:.04em;text-transform:uppercase;font-weight:600;padding:14px 10px;border:0;white-space:nowrap}
        .sr-inner tbody td{padding:12px 10px;vertical-align:middle;border:0;border-top:1px solid #f0f1f4;font-size:.85rem;color:#0f1f3d;white-space:nowrap}
      `}</style>
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="card mb-4">
                <h5 className="card-header">Filter Options</h5>
                <div className="card-body">
                  <div className="row gy-3 align-items-end">
                    <div className="col-md-3 col-6">
                      <label>From Date</label>
                      <div className="input-group">
                        <button
                          className="btn btn-outline-primary d-none d-sm-block"
                          type="button"
                        >
                          From
                        </button>
                        <DatePicker
                          className="form-control btn-block"
                          dateFormat="MM/dd/yyyy"
                          selected={showDateFrom}
                          onChange={handleDateFrom}
                          placeholderText={todatdate}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 col-6">
                      <label>To Date</label>
                      <div className="input-group">
                        <button
                          className="btn btn-outline-primary d-none d-sm-block"
                          type="button"
                        >
                          To
                        </button>
                        <DatePicker
                          className="form-control btn-block"
                          dateFormat="MM/dd/yyyy"
                          selected={showDateTo}
                          onChange={handleDateTo}
                          placeholderText={todatdate}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Select User</label>
                      <select
                        defaultValue={selectUser}
                        onChange={accountTyeHandlar}
                        name="smsc"
                        className="form-select"
                      >
                        <option value="">All users</option>
                        {userList.map((items, i) => (
                          <option key={i} value={items.system_id}>
                            {items.system_id}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2 col-12">
                      <button
                        onClick={summaryReport}
                        disabled={isloading}
                        className="btn btn-primary w-100"
                        type="button"
                      >
                        {isloading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faSearch} className="me-2" />
                            Search
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                </div>
              ) : null}

              {uniqueData.length > 0 && (
                <div className="row mb-4">
                  {[
                    { label: "Total Sent", value: grand.t, cls: "text-secondary" },
                    { label: "Delivered", value: grand.d, cls: "text-success" },
                    { label: "Failed", value: grand.f, cls: "text-danger" },
                  ].map((k) => (
                    <div className="col-md-4 col-12 mb-3 mb-md-0" key={k.label}>
                      <div className="card">
                        <div className="card-body">
                          <span className="fw-semibold d-block mb-1">
                            {k.label}
                          </span>
                          <h3 className={"card-title mb-0 " + k.cls}>
                            {k.value}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {uniqueData.length > 0 && (
                <div className="row mb-4">
                  {[
                    {
                      label: "Total Customer Billing",
                      value: billing.customer,
                      cls: "text-secondary",
                    },
                    {
                      label: "Total Vendor Billing",
                      value: billing.vendor,
                      cls: "text-secondary",
                    },
                    {
                      label: "Profit/Loss",
                      value: billing.profit,
                      cls: billing.profit >= 0 ? "text-success" : "text-danger",
                    },
                  ].map((k) => (
                    <div className="col-md-4 col-12 mb-3 mb-md-0" key={k.label}>
                      <div className="card">
                        <div className="card-body">
                          <span className="fw-semibold d-block mb-1">
                            {k.label}
                          </span>
                          <h3
                            className={
                              "card-title mb-0 " + (billingLoaded ? k.cls : "text-muted")
                            }
                          >
                            {billingLoaded ? fmtCost(k.value) : "…"}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="card sr-panel">
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 sr-panel-head">
                  <div>
                    <h4 className="sr-h1">Summary Report</h4>
                    <p className="sr-h1-sub">
                      View user wise message statistics and detailed country
                      breakdown.
                    </p>
                  </div>
                  {/* <div className="sr-range">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    <span>
                      {fmtDate(DateFrom)} – {fmtDate(DateTo)}
                    </span>
                    <FontAwesomeIcon icon={faChevronDown} />
                  </div> */}
                </div>

                <div className="table-responsive text-nowrap sr-panel-body">
                  {uniqueData.length === 0 ? (
                    <div className="sr-empty">
                      Choose a date range and account, then press Search.
                    </div>
                  ) : (
                    <table className="sr-main">
                      <thead>
                        <tr>
                          <th style={{ width: 40 }}></th>
                          <th>
                            User Name{" "}
                            <FontAwesomeIcon icon={faSort} className="ms-1" />
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                            Total Sent
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                            Delivered
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                            Failed
                          </th>
                          <th>
                            <FontAwesomeIcon icon={faClock} className="me-2" />
                            DLR Await
                          </th>
                          <th>Customer Cost</th>
                          <th>Vendor Cost</th>
                          <th>Profit/Loss</th>
                          <th>Reports</th>
                          <th style={{ width: 40 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {uniqueData.map((item, i) => {
                          const s = totalsOf(item.count);
                          const isOpen = !!openRows[item.username];
                          const details = rowDetails[item.username] || [];
                          const costs = userCosts(item.username);
                          return (
                            <React.Fragment key={i}>
                              <tr
                                className="sr-main-row"
                                onClick={() => toggleRow(item.username)}
                              >
                                <td className="text-center">
                                  <FontAwesomeIcon
                                    icon={isOpen ? faChevronDown : faChevronRight}
                                    className="sr-chev"
                                  />
                                </td>
                                <td>
                                  <span className="sr-uname">{item.username}</span>
                                </td>
                                <td className="sr-strong">{fmt(s.t)}</td>
                                <td>
                                  <div className="sr-stat sr-green">
                                    <b>{fmt(s.d)}</b>{" "}
                                    <span>({pct(s.d, s.t)}%)</span>
                                  </div>
                                  {/* <div className="sr-track">
                                    <span
                                      style={{
                                        width: pct(s.d, s.t) + "%",
                                        background: "#3fae7a",
                                      }}
                                    />
                                  </div> */}
                                </td>
                                <td>
                                  <div className="sr-stat sr-red">
                                    <b>{fmt(s.f)}</b>{" "}
                                    <span>({pct(s.f, s.t)}%)</span>
                                  </div>
                                  {/* <div className="sr-track">
                                    <span
                                      style={{
                                        width: pct(s.f, s.t) + "%",
                                        background: "#e5484d",
                                      }}
                                    />
                                  </div> */}
                                </td>
                                <td>
                                  <div className="sr-stat sr-amber">
                                    <b>{fmt(s.o)}</b>{" "}
                                    <span>({pct(s.o, s.t)}%)</span>
                                  </div>
                                </td>
                                <td className="sr-strong">
                                  {costs ? (costs.matched ? fmtCost(costs.customer) : "-") : "…"}
                                </td>
                                <td className="sr-strong">
                                  {costs ? (costs.matched ? fmtCost(costs.vendor) : "-") : "…"}
                                </td>
                                <td
                                  className={
                                    "sr-strong " +
                                    (costs && costs.matched
                                      ? costs.profit >= 0
                                        ? "sr-green"
                                        : "sr-red"
                                      : "")
                                  }
                                >
                                  {costs ? (costs.matched ? fmtCost(costs.profit) : "-") : "…"}
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                  <div className="d-flex gap-2">
                                    {/* <Link
                                      to={
                                        "/admin/summary-sender-report/" +
                                        item.username +
                                        "/" +
                                        DateFrom +
                                        "/" +
                                        DateTo
                                      }
                                      className="sr-pill-btn"
                                    >
                                      <FontAwesomeIcon icon={faEye} /> Sender ID
                                    </Link> */}
                                    <Link
                                      to={
                                        "/admin/summary-date-report/" +
                                        item.username +
                                        "/" +
                                        DateFrom +
                                        "/" +
                                        DateTo
                                      }
                                      className="sr-pill-btn"
                                      target="_blank"
                                    >
                                      <FontAwesomeIcon icon={faCalendarAlt} /> Date
                                    </Link>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {isOpen && (
                                    <FontAwesomeIcon
                                      icon={faChevronUp}
                                      className="sr-chev"
                                    />
                                  )}
                                </td>
                              </tr>
                              {isOpen && (
                                <tr>
                                  <td colSpan={11} className="p-0 sr-open-cell">
                                    <div className="sr-break">
                                      {rowLoading[item.username] ? (
                                        <div className="text-center text-muted py-3">
                                          Loading...
                                        </div>
                                      ) : (
                                        <>
                                          <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="d-flex align-items-center gap-3">
                                              <FontAwesomeIcon
                                                icon={faGlobe}
                                                className="sr-globe"
                                              />
                                              <div>
                                                <div className="sr-break-title">
                                                  Country Breakdown
                                                </div>
                                                <div className="sr-break-sub">
                                                  Message statistics for {item.username}
                                                </div>
                                              </div>
                                            </div>
                                            <span className="sr-count-pill">
                                              Total Countries: {details.length}
                                            </span>
                                          </div>
                                          <div className="sr-inner-wrap">
                                            <table className="sr-inner">
                                              <thead>
                                                <tr>
                                                  <th>Country Code</th>
                                                  <th>Total Sent</th>
                                                  <th>Delivered</th>
                                                  <th>Failed</th>
                                                  <th>DLR Await</th>
                                                  <th>Customer Cost</th>
                                                  <th>Vendor Cost</th>
                                                  <th>Profit/Loss</th>
                                                  <th>Submit Date</th>
                                                  <th>Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {details.length === 0 && (
                                                  <tr>
                                                    <td colSpan={10} className="text-center text-muted">
                                                      No records found
                                                    </td>
                                                  </tr>
                                                )}
                                                {details.map((d, j) => {
                                                  const ds = totalsOf(d.count);
                                                  const price = findPrice(item.username, d.sernderid);
                                                  return (
                                                    <tr key={j}>
                                                      <td className="sr-strong">
                                                        {getCountryName(companyList, d.sernderid)}
                                                      </td>
                                                      <td className="sr-strong">{fmt(ds.t)}</td>
                                                      <td className="sr-green">
                                                        {fmt(ds.d)} ({pct(ds.d, ds.t)}%)
                                                      </td>
                                                      <td className="sr-red">
                                                        {fmt(ds.f)} ({pct(ds.f, ds.t)}%)
                                                      </td>
                                                      <td className="sr-amber">
                                                        {fmt(ds.o)} ({pct(ds.o, ds.t)}%)
                                                      </td>
                                                      <td className="sr-strong">
                                                        {price ? fmtCost(price.cost * ds.t) : "-"}
                                                      </td>
                                                      <td className="sr-strong">
                                                        {price ? fmtCost(price.buy_price * ds.t) : "-"}
                                                      </td>
                                                      <td className="sr-strong">
                                                        {price ? fmtCost((price.cost - price.buy_price) * ds.t) : "-"}
                                                      </td>
                                                      <td>{d.date}</td>
                                                      <td>
                                                        <Link
                                                          to={
                                                            "/admin/details-report/" +
                                                            item.username +
                                                            "/" +
                                                            d.sernderid +
                                                            "/" +
                                                            DateFrom +
                                                            "/" +
                                                            DateTo
                                                          }
                                                          className="sr-pill-btn sr-sm"
                                                        >
                                                          <FontAwesomeIcon icon={faChartArea} /> View
                                                        </Link>
                                                      </td>
                                                    </tr>
                                                  );
                                                })}
                                              </tbody>
                                            </table>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryReport;
